module.exports = function getResource(label, vars = []) {
    let resources = {
        joinButton: 'Join',
        createAccount: 'Create an Account'
    };

    return resources[label];
};
